/**
 * Styled content wrapper for vertical layout.
 * Based on Vuexy styled components.
 */

// Third-party Imports
import styled from '@emotion/styled';

// Util Imports
import { commonLayoutClasses, verticalLayoutClasses } from '@layouts/utils/layoutClasses';

const StyledContentWrapper = styled.div`
  &:has(.${verticalLayoutClasses.content}>.${commonLayoutClasses.contentHeightFixed}) {
    max-block-size: 100dvh;
  }
`;

export default StyledContentWrapper;
